// extracted by mini-css-extract-plugin
module.exports = {"buildPath":"BuildPathAndStatus__buildPath--iQ","separator":"BuildPathAndStatus__separator--R6"};